// Copyright (C) 2022 by Posit Software, PBC.

export const SALES_EMAIL = 'sales@posit.co';
export const SUPPORT_EMAIL = 'support@posit.co';
